module.exports = __webpack_public_path__ + "img/left-right-arrow.a7fe6b25.svg";